// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-text-preview-options][data-v-3fb42e22]{position:absolute;left:-44px}`, "",{"version":3,"sources":["webpack://./src/components/Editor/PreviewOptions.vue"],"names":[],"mappings":"AAEA,6CACC,iBAAA,CACA,UAAA","sourcesContent":["\n\n[data-text-preview-options] {\n\tposition: absolute;\n\tleft: -44px;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
